<template>
  <div>
    <div class="card-data" >
      <ul class="list-header">
        <li class="img-header">Imagen</li>
        <li class="title-header">Título y descripción</li>
        <li class="category-header">Categoría</li>
        <li class="interaction-header">Interacción</li>
        <li class="start-date-header">Fecha inicio</li>
        <li class="end-date-header">Fecha término</li>
        <li class="perfil-header">perfil</li>
        <li class="status-header">Estado</li>
        <li class="actions-header">Acciones</li>
      </ul>
      
        <draggable v-model="localData" group="contents" @start="drag=true" @end="drag=false" @update="handleUpdate" style="max-height: 64vh; overflow-y: auto;" >
        <transition-group>
          <ItemList class="itemlist" v-for="(item,key) in localData" :key="key" 
          :title="item.name"
          :desc="item.description"
          :interaction="item.action_type"
          :startdate="item.init_date"
          :enddate="item.end_date"
          :is_active="item.is_active"
          :profile_id="item.profile_id[0] || 'x'"
          :cat="item.category[0].id"
          :offer_id="item.id"
          :image="item.images"
          :item="item"
          @deleteContent="deleteContent(item.id)"
          @checkContent="checkContent(item.id)"
          @performanceContent="performanceContent(item.id)"          
          />
        </transition-group>
      </draggable>
    </div>
  </div>
</template>

<script>
import ItemList from "@/components/ItemList"
import draggable from 'vuedraggable';
export default {
  name: 'ContentList',
  components:{
    ItemList,
    draggable,
  },
  props: {
        data: {
            type: Array,
            required: true
        }
  },
  data() {
    return {
      localData: []
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(newValue) {
        this.localData = [...newValue]
      }
    }
  },

  methods: {
    deleteContent: function(id){
      this.$emit('deleteContent', id);
    },
    checkContent: function(id){
      this.$emit('checkContent', id);
    },
    performanceContent: function(id){
      this.$emit('performanceContent', id);
    },
    handleUpdate() {
      this.$emit('orderContent', this.localData);
    },
  },
}
</script>

<style lang="sass">
.list-header
  display: flex
  flex-direction: row
  justify-content: flex-start
  box-sizing: border-box
  grid-column-start: 2
  grid-column-end: -2
  align-items: center
  height: 24px
  margin: $sm $xs
  border-bottom: 1px solid $secondary
  
  li
    font-family: $body-font
    font-size: 12px
    font-weight: bold
    list-style-type: none
    text-align: center
    min-width: 56px
    margin: 0 $xs
    height: 24px
    box-sizing: border-box
    &:first-child
      margin-left: 15px
    &:last-child
      margin-right: 0px
    &.img-header
      width: calc(100%/18)
      display: flex
      justify-content: center
    &.title-header
      width: calc(100%/5)
      display: flex
      justify-content: center
      padding: 0 $xs
    &.category-header
      width: calc(100%/10)
      display: block
      text-align: center
    &.interaction-header
      width: calc(100%/10)
      display: flex
      justify-content: center
    &.start-date-header
      width: calc(100%/10)
      display: flex
      justify-content: center
    &.perfil-header
      width: calc(100%/10)
      display: flex
      justify-content: center
    &.end-date-header
      width: calc(100%/10)
      display: flex
      justify-content: center
    &.status-header
      width: calc(100%/18)
      display: flex
      justify-content: center
    &.actions-header
      width: calc(100%/5)
      display: flex
      justify-content: center
.itemlist
  grid-column: 2/3


</style>